module.exports = __webpack_public_path__ + "22524e25aa1908e7fc239a6d21cd5940.pdf";